import script from "./FeedbackView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackView.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackView.vue?vue&type=style&index=0&id=83688c34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83688c34"]])

export default __exports__